import React from 'react';

interface StatsProps {
  stats: {
    totalEarnings: number;
    totalQuestions: number;
    approvedQuestions: number;
    pendingQuestions: number;
    rejectedQuestions: number;
    questionsThisMonth: number;
    earningsThisMonth: number;
  } | null;
}

export const ContentCreatorStats: React.FC<StatsProps> = ({ stats }) => {
  if (!stats) return null;

  const statItems = [
    {
      name: 'Total Earnings',
      value: `KES ${stats.totalEarnings.toFixed(2)}`,
      description: 'Total earnings from approved questions',
    },
    {
      name: 'Total Questions',
      value: stats.totalQuestions,
      description: 'Total questions submitted',
    },
    {
      name: 'Approved Questions',
      value: stats.approvedQuestions,
      description: 'Questions approved and published',
    },
    {
      name: 'Pending Questions',
      value: stats.pendingQuestions,
      description: 'Questions under review',
    },
    {
      name: 'Rejected Questions',
      value: stats.rejectedQuestions,
      description: 'Questions that need revision',
    },
    {
      name: 'This Month',
      value: `${stats.questionsThisMonth} questions, KES ${stats.earningsThisMonth.toFixed(2)}`,
      description: 'Questions and earnings this month',
    },
  ];

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-lg font-medium text-gray-900 mb-4">Your Statistics</h2>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {statItems.map((item) => (
          <div
            key={item.name}
            className="bg-gray-50 overflow-hidden shadow rounded-lg"
          >
            <div className="px-4 py-5 sm:p-6">
              <dt className="text-sm font-medium text-gray-500 truncate">
                {item.name}
              </dt>
              <dd className="mt-1 text-3xl font-semibold text-indigo-600">
                {item.value}
              </dd>
              <dd className="mt-1 text-sm text-gray-500">
                {item.description}
              </dd>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 